export const TRANSLATIONS = {
  nl: {
    // Global
    app_tagline: "micro-learning voor retail",
    loading: "Laden...",
    or: "of",

    // Language switcher
    language_label: "Taal",
    language_nl: "Nederlands",
    language_en: "English",

    // Login
    login_title: "Inloggen",
    login_subtitle: "Log in om je Qoldo-items te beheren.",
    login_email_label: "E-mailadres",
    login_email_placeholder: "jouw@email.nl",
    login_send_code: "Stuur login code",
    login_sending: "Versturen...",
    login_code_sent: "Login code verstuurd! Check je inbox.",
    login_enter_code_title: "Vul je code in",
    login_enter_code_help: "We hebben een 6-cijferige code naar je e-mailadres gestuurd.",
    login_code_label: "Login code",
    login_verify: "Inloggen",
    login_verifying: "Verifiëren...",
    login_use_other_email: "Andere e-mail gebruiken",
    login_code_info: "Je ontvangt een eenmalige code om in te loggen",
    login_error_not_allowed: "Dit e-mailadres heeft geen toegang tot Qoldo.",
    login_dev_mode_warning: "Dev modus: Alleen voor lokale ontwikkeling. In productie wordt e-mail verificatie gebruikt.",
    login_username_placeholder: "Gebruikersnaam",
    login_button: "Inloggen",
    login_logging_in: "Inloggen...",

    // Dashboard
    dashboard_title: "Mijn items",
    dashboard_subtitle: "Maak en beheer micro-learning items",
    dashboard_new_course: "Nieuw item",
    dashboard_no_courses: "Nog geen items. Maak je eerste!",
    dashboard_create_course: "Maak item",
    dashboard_status_published: "Gepubliceerd",
    dashboard_status_unpublished: "Offline",
    dashboard_status_draft: "Concept",
    dashboard_blocks: "blokken",
    dashboard_edit: "Bewerken",
    dashboard_view: "Bekijken",
    dashboard_share: "Delen",
    dashboard_stats: "Stats",
    dashboard_unpublish: "Offline zetten",
    dashboard_publish_again: "Weer publiceren",
    dashboard_delete_confirm: "Weet je zeker dat je dit item wilt verwijderen?",
    dashboard_unpublish_title: "Offline zetten",
    dashboard_unpublish_confirm: "Weet je zeker dat je {title} offline wilt halen?",
    dashboard_unpublish_info: "De publieke link zal niet meer werken. Je kunt later weer publiceren.",
    dashboard_cancel: "Annuleren",
    dashboard_confirm_unpublish: "Ja, offline zetten",
    dashboard_reels: "Reels",

    // Editor
    editor_title_new: "Nieuw item",
    editor_title_edit: "Item bewerken",
    editor_save: "Opslaan",
    editor_saving: "Opslaan...",
    editor_publish: "Publiceren",
    editor_course_details: "Details",
    editor_title_label: "Titel *",
    editor_title_placeholder: "Voer titel in",
    editor_description_label: "Beschrijving",
    editor_description_placeholder: "Voer beschrijving in",
    editor_blocks_title: "Blokken",
    editor_no_blocks: "Nog geen blokken. Voeg je eerste blok toe vanuit het paneel →",
    editor_add_block: "Blok toevoegen",
    editor_block_text: "Tekst",
    editor_block_image: "Afbeelding",
    editor_block_video: "Video (9:16)",
    editor_block_audio: "Audio",
    editor_block_quiz: "Quiz",
    editor_block_cta: "CTA",
    editor_add_block_before_publish: "Voeg minstens één blok toe voordat je publiceert",
    
    // Video viewing requirement
    video_viewing_requirement: "Kijkvereiste",
    video_skippable: "Overslaan toegestaan",
    video_skippable_desc: "Deelnemer kan meteen doorgaan",
    video_must_finish: "Video moet afgekeken worden",
    video_must_finish_desc: "Deelnemer moet de video uitkijken om door te gaan",
    video_watch_hint: "Bekijk deze video tot het einde om door te gaan",
    video_watched_hint: "Je hebt de video bekeken. Je kunt doorgaan.",
    
    // Client/Brand
    course_client_label: "Voor welke doelgroep is dit bedoeld?",
    course_client_select_placeholder: "Selecteer een doelgroep...",
    course_client_stores_title: "Dit item wordt getoond aan winkels:",
    course_client_no_stores: "Geen winkels voor deze doelgroep",
    analytics_client_label: "Klant",

    // Share page
    share_title: "Deel Training",
    share_qr_title: "QR Code & Deellink",
    share_qr_description: "Genereer een link en QR code om dit item te delen met je team.",
    share_qr_sub: "Print de QR code of deel de link via WhatsApp, e-mail, etc.",
    share_generate: "Genereer Deellink",
    share_generating: "Genereren...",
    share_link_title: "Training Deellink",
    share_link_description: "Gebruik deze link of QR code om dit item te delen met medewerkers",
    share_scan_hint: "Scan met een smartphone camera",
    share_download_qr: "Download QR Code",
    share_direct_link: "Directe link",
    share_copy: "Kopieer",
    share_copied: "Gekopieerd",
    share_tip_title: "💡 Tip",
    share_tip_text: "Print de QR code en hang deze op in de winkel of kantoorruimte. Medewerkers kunnen het item starten door de code te scannen met hun telefoon.",
    share_new_link: "Nieuwe link genereren",
    share_old_link_works: "De oude link blijft ook werken",

    // Analytics
    analytics_title: "Analytics",
    analytics_export: "Export CSV",
    analytics_export_excel: "Download Excel",
    analytics_views: "Weergaven",
    analytics_starts: "Gestart",
    analytics_completions: "Voltooid",
    analytics_avg_time: "Gem. tijd",
    analytics_completion_rate: "Voltooiingspercentage",
    analytics_of_learners: "van de deelnemers die gestart zijn",
    analytics_quiz_accuracy: "Quiz nauwkeurigheid",
    analytics_avg_correct: "gemiddeld correcte antwoorden",
    analytics_responses: "Antwoorden",
    analytics_responses_submitted: "antwoorden ingediend",
    analytics_questions_answered: "Vragen beantwoord",
    analytics_answer_overview: "Antwoordoverzicht",
    analytics_answer_label: "Antwoord:",
    analytics_comment_label: "Opmerking:",
    // Reset test data
    analytics_reset_button: "Testresultaten wissen",
    analytics_reset_tooltip: "Verwijder alle huidige resultaten voor deze training. Gebruik dit om testdata te wissen voordat je live gaat.",
    analytics_reset_dialog_title: "Testresultaten wissen?",
    analytics_reset_dialog_message: "Dit verwijdert alle huidige resultaten (weergaven, starts, completions, quiz-scores en feedback) voor deze training. De inhoud van de training blijft behouden. Deze actie kan niet ongedaan worden gemaakt. Wil je doorgaan?",
    analytics_reset_cancel: "Annuleren",
    analytics_reset_confirm: "Ja, wis alle testresultaten",
    analytics_reset_success: "Testresultaten succesvol gewist",
    analytics_reset_error: "Het is niet gelukt om de resultaten te wissen. Probeer het later opnieuw.",
    // Per-store reset
    analytics_reset_store_button: "Resultaten wissen",
    analytics_reset_store_dialog_title: "Resultaten voor deze winkel wissen?",
    analytics_reset_store_dialog_message: "Dit verwijdert alle resultaten voor {storeName}. Resultaten van andere winkels blijven behouden. Deze actie kan niet ongedaan worden gemaakt.",
    analytics_reset_store_confirm: "Ja, wis resultaten",
    analytics_reset_store_success: "Resultaten voor deze winkel gewist",
    analytics_reset_store_error: "Het is niet gelukt om de resultaten te wissen.",
    // Analytics tabs & store breakdown
    analytics_tab_overview: "Overzicht",
    analytics_tab_by_store: "Per winkel",
    analytics_tab_by_participant: "Per deelnemer",
    analytics_tab_feedback: "Feedback",
    analytics_stores_title: "Resultaten per winkel",
    analytics_export_stores: "Download CSV",
    analytics_export_participants: "Download CSV",
    analytics_export_feedback: "Download CSV",
    analytics_store: "Winkel",
    analytics_learners: "Deelnemers",
    analytics_unique_learners: "Unieke deelnemers",
    analytics_started: "Gestart",
    analytics_completed: "Voltooid",
    analytics_avg_score: "Gem. score",
    analytics_no_store_data: "Nog geen data per winkel beschikbaar",
    analytics_participants: "deelnemers",
    analytics_participants_in_store: "Deelnemers in {store}",
    analytics_no_participants: "Geen deelnemers gevonden",
    analytics_last_activity: "Laatste activiteit",
    analytics_first_activity: "Eerste activiteit",
    analytics_status_completed: "Voltooid",
    analytics_status_started: "Gestart",
    analytics_status_not_started: "Niet gestart",
    // Feedback table
    analytics_feedback_title: "Feedback van deelnemers",
    analytics_feedback_date: "Datum",
    analytics_feedback_time: "Tijd",
    analytics_feedback_store: "Winkel",
    analytics_feedback_name: "Naam",
    analytics_feedback_text: "Feedback",
    analytics_feedback_language: "Taal",
    analytics_no_feedback: "Nog geen feedback ontvangen",
    analytics_feedback_count: "{count} feedback berichten",
    analytics_attempts: "Pogingen",
    analytics_quiz_score: "Quiz score",
    analytics_correct_answers: "Correcte antwoorden",
    analytics_total_questions: "Totaal vragen",
    analytics_time_spent: "Tijd besteed",
    analytics_score: "Score",
    analytics_status: "Status",
    analytics_participant_name: "Naam deelnemer",
    analytics_date_range: "Periode",
    analytics_filter_training: "Training",
    analytics_filter_store: "Winkel",
    // CSV column headers (must match backend)
    analytics_csv_store_id: "Winkel ID",
    analytics_csv_store_name: "Winkel",
    analytics_csv_views: "Weergaven",
    analytics_csv_started: "Gestart",
    analytics_csv_completed: "Voltooid",
    analytics_csv_completion_rate: "Voltooiingspercentage",
    analytics_csv_avg_score: "Gem. score",
    analytics_csv_unique_learners: "Unieke deelnemers",
    analytics_csv_learner_name: "Naam deelnemer",
    analytics_csv_first_name: "Voornaam",
    analytics_csv_last_name: "Familienaam",
    analytics_csv_status: "Status",
    analytics_csv_attempts: "Pogingen",
    analytics_csv_total_questions: "Totaal vragen",
    analytics_csv_correct_answers: "Correcte antwoorden",
    analytics_csv_score_percent: "Score %",
    analytics_csv_time_spent: "Tijd (sec)",
    analytics_csv_first_activity: "Eerste activiteit",
    analytics_csv_last_activity: "Laatste activiteit",
    analytics_csv_feedback_text: "Feedback",
    analytics_csv_timestamp: "Tijdstip",

    // Player – start screen
    player_start_title: "Welkom bij deze training",
    player_start_welcome: "Welkom bij {courseName}",
    player_start_intro: "Bevestig je gegevens om te beginnen",
    player_start_store_label: "Bij welke winkel werk je? *",
    player_start_store_label_mystery_shop: "Welke winkel bezoek je? *",
    player_start_store_label_guide: "Voor welke context bekijk je dit? *",
    player_start_store_placeholder: "Selecteer je winkel",
    player_start_store_error: "Selecteer een winkel",
    player_start_first_name_label: "Voornaam *",
    player_start_first_name_placeholder: "Jouw voornaam",
    player_start_first_name_error: "Voornaam is verplicht",
    player_start_last_name_label: "Familienaam *",
    player_start_last_name_placeholder: "Jouw familienaam",
    player_start_last_name_error: "Familienaam is verplicht",
    player_start_info: "Deze informatie helpt ons de training te verbeteren en is gekoppeld aan je voortgang.",
    player_start_button: "Start Training",
    player_start_button_mystery_shop: "Start bezoek",
    player_start_button_guide: "Open handleiding",

    // Player – nav
    player_nav_previous: "Vorige",
    player_nav_next: "Volgende",
    player_nav_finish: "Voltooien",
    player_watch_more: "Bekijk nog {seconds} seconden",
    player_watch_to_end: "Bekijk eerst de video tot het einde",
    player_wait_more: "Wacht nog {seconds} seconden",
    player_complete_first: "Voltooi eerst dit onderdeel",

    // Player – quiz
    quiz_select_answer: "Selecteer een antwoord",
    quiz_confirm: "Bevestig Antwoord",
    quiz_your_answer: "Jouw antwoord",
    quiz_reflection: "Deze vraag heeft geen goed of fout antwoord. Het is voor reflectie.",
    quiz_reflection_mystery_shop: "Geef je observatie. Er is geen goed of fout antwoord.",
    quiz_reflection_guide: "Er is geen goed of fout antwoord.",
    quiz_comment_label: "Toelichting (optioneel)",
    quiz_comment_placeholder: "Voeg een opmerking toe...",
    quiz_comment_submit: "Opmerking opslaan",
    quiz_comment_skipped: "Geen opmerking toegevoegd",
    quiz_correct: "Correct! 🎉",
    quiz_incorrect: "Niet helemaal...",
    quiz_expl_correct_label: "Uitleg bij juist antwoord (optioneel)",
    quiz_expl_correct_placeholder: "Wordt getoond als de leerling het juiste antwoord kiest...",
    quiz_expl_incorrect_label: "Uitleg bij fout antwoord (optioneel)",
    quiz_expl_incorrect_placeholder: "Wordt getoond als de leerling een fout antwoord kiest...",
    quiz_explanation_label: "Algemene uitleg (optioneel, deprecated)",
    quiz_multiple_answers: "Meerdere antwoorden toestaan",
    quiz_single_answer_hint: "Eén antwoord mogelijk (radio)",
    quiz_multiple_answer_hint: "Meerdere antwoorden mogelijk (checkbox)",
    quiz_locked: "Je antwoord is opgeslagen",

    // Player – completion + feedback
    completion_title: "Training voltooid!",
    completion_title_mystery_shop: "Bezoek voltooid!",
    completion_title_guide: "Handleiding doorlopen",
    completion_subtitle: "Je hebt {courseName} succesvol afgerond",
    completion_subtitle_mystery_shop: "Bedankt voor je bezoek!",
    completion_subtitle_guide: "Goed gedaan! Je hebt de handleiding doorlopen.",
    completion_name_label: "Naam",
    completion_store_label: "Winkel",
    feedback_title: "Optionele Feedback",
    feedback_help: "Help ons deze training te verbeteren. Wat vond je goed? Wat kan beter?",
    feedback_help_mystery_shop: "Hoe was je ervaring?",
    feedback_help_guide: "Hoe vond je deze handleiding?",
    feedback_placeholder: "Deel je ervaringen, tips, of suggesties...",
    feedback_chars: "karakters",
    feedback_submit: "Verstuur Feedback & Sluit",
    feedback_submitting: "Verzenden...",
    feedback_skip: "Overslaan",
    feedback_sent_title: "Feedback verzonden!",
    feedback_sent_body: "Bedankt voor je feedback.",
    feedback_enter_first: "Voer eerst feedback in",

    // Closed screen
    closed_title: "Je bent klaar 🎉",
    closed_body: "Je kunt dit venster nu sluiten.",

    // Misc
    error_media_could_not_load: "Media kon niet worden geladen. Je kunt doorgaan.",
    unavailable_title: "Training niet beschikbaar",
    not_found: "Niet gevonden"
  },

  en: {
    // Global
    app_tagline: "micro-learning for retail",
    loading: "Loading...",
    or: "or",

    // Language switcher
    language_label: "Language",
    language_nl: "Dutch",
    language_en: "English",

    // Login
    login_title: "Sign in",
    login_subtitle: "Sign in to manage your Qoldo items.",
    login_email_label: "Email address",
    login_email_placeholder: "you@email.com",
    login_send_code: "Send sign-in code",
    login_sending: "Sending...",
    login_code_sent: "Code sent! Check your inbox.",
    login_enter_code_title: "Enter your code",
    login_enter_code_help: "We've sent a 6-digit code to your email address.",
    login_code_label: "Sign-in code",
    login_verify: "Sign in",
    login_verifying: "Verifying...",
    login_use_other_email: "Use different email",
    login_code_info: "You'll receive a one-time code to sign in",
    login_error_not_allowed: "This email address does not have access to Qoldo.",
    login_dev_mode_warning: "Dev mode: For local development only. In production, email verification is used.",
    login_username_placeholder: "Username",
    login_button: "Sign in",
    login_logging_in: "Signing in...",

    // Dashboard
    dashboard_title: "My items",
    dashboard_subtitle: "Create and manage micro-learning items",
    dashboard_new_course: "New item",
    dashboard_no_courses: "No items yet. Create your first one!",
    dashboard_create_course: "Create item",
    dashboard_status_published: "Published",
    dashboard_status_unpublished: "Offline",
    dashboard_status_draft: "Draft",
    dashboard_blocks: "blocks",
    dashboard_edit: "Edit",
    dashboard_view: "View",
    dashboard_share: "Share",
    dashboard_stats: "Stats",
    dashboard_unpublish: "Unpublish",
    dashboard_publish_again: "Publish again",
    dashboard_delete_confirm: "Are you sure you want to delete this item?",
    dashboard_unpublish_title: "Unpublish",
    dashboard_unpublish_confirm: "Are you sure you want to unpublish {title}?",
    dashboard_unpublish_info: "The public link will stop working. You can publish it again later.",
    dashboard_cancel: "Cancel",
    dashboard_confirm_unpublish: "Yes, unpublish",
    dashboard_reels: "Reels",

    // Editor
    editor_title_new: "New item",
    editor_title_edit: "Edit item",
    editor_save: "Save",
    editor_saving: "Saving...",
    editor_publish: "Publish",
    editor_course_details: "Details",
    editor_title_label: "Title *",
    editor_title_placeholder: "Enter title",
    editor_description_label: "Description",
    editor_description_placeholder: "Enter description",
    editor_blocks_title: "Blocks",
    editor_no_blocks: "No blocks yet. Add your first block from the panel →",
    editor_add_block: "Add block",
    editor_block_text: "Text",
    editor_block_image: "Image",
    editor_block_video: "Video (9:16)",
    editor_block_audio: "Audio",
    editor_block_quiz: "Quiz",
    editor_block_cta: "CTA",
    editor_add_block_before_publish: "Add at least one block before publishing",
    
    // Video viewing requirement
    video_viewing_requirement: "Viewing requirement",
    video_skippable: "Skippable",
    video_skippable_desc: "Learner can continue at any time",
    video_must_finish: "Must finish video",
    video_must_finish_desc: "Learner must watch video to the end to continue",
    video_watch_hint: "Watch this video until the end to continue",
    video_watched_hint: "You've finished the video. You can continue.",
    
    // Client/Brand
    course_client_label: "Which audience is this intended for?",
    course_client_select_placeholder: "Select an audience...",
    course_client_stores_title: "This item will be shown to these stores:",
    course_client_no_stores: "No stores for this audience",
    analytics_client_label: "Client",

    // Share page
    share_title: "Share Training",
    share_qr_title: "QR Code & Share Link",
    share_qr_description: "Generate a link and QR code to share this item with your team.",
    share_qr_sub: "Print the QR code or share the link via WhatsApp, email, etc.",
    share_generate: "Generate Share Link",
    share_generating: "Generating...",
    share_link_title: "Training Share Link",
    share_link_description: "Use this link or QR code to share this item with employees",
    share_scan_hint: "Scan with a smartphone camera",
    share_download_qr: "Download QR Code",
    share_direct_link: "Direct link",
    share_copy: "Copy",
    share_copied: "Copied",
    share_tip_title: "💡 Tip",
    share_tip_text: "Print the QR code and display it in the store or office. Employees can start the item by scanning the code with their phone.",
    share_new_link: "Generate new link",
    share_old_link_works: "The old link will still work",

    // Analytics
    analytics_title: "Analytics",
    analytics_export: "Export CSV",
    analytics_export_excel: "Download Excel",
    analytics_views: "Views",
    analytics_starts: "Starts",
    analytics_completions: "Completions",
    analytics_avg_time: "Avg time",
    analytics_completion_rate: "Completion rate",
    analytics_of_learners: "of learners who started",
    analytics_quiz_accuracy: "Quiz accuracy",
    analytics_avg_correct: "average correct answers",
    analytics_responses: "Responses",
    analytics_responses_submitted: "responses submitted",
    analytics_questions_answered: "Questions answered",
    analytics_answer_overview: "Answer overview",
    analytics_answer_label: "Answer:",
    analytics_comment_label: "Comment:",
    // Reset test data
    analytics_reset_button: "Clear test results",
    analytics_reset_tooltip: "Delete all current results for this training. Use this to clear test data before going live.",
    analytics_reset_dialog_title: "Clear test results?",
    analytics_reset_dialog_message: "This will delete all current results (views, starts, completions, quiz scores and feedback) for this training. The training content will be preserved. This action cannot be undone. Do you want to continue?",
    analytics_reset_cancel: "Cancel",
    analytics_reset_confirm: "Yes, clear all test results",
    analytics_reset_success: "Test results cleared successfully",
    analytics_reset_error: "Failed to clear results. Please try again later.",
    // Per-store reset
    analytics_reset_store_button: "Clear results",
    analytics_reset_store_dialog_title: "Clear results for this store?",
    analytics_reset_store_dialog_message: "This will delete all results for {storeName}. Results from other stores will be preserved. This action cannot be undone.",
    analytics_reset_store_confirm: "Yes, clear results",
    analytics_reset_store_success: "Results for this store cleared",
    analytics_reset_store_error: "Failed to clear results for this store.",
    // Analytics tabs & store breakdown
    analytics_tab_overview: "Overview",
    analytics_tab_by_store: "By store",
    analytics_tab_by_participant: "By participant",
    analytics_tab_feedback: "Feedback",
    analytics_stores_title: "Results by store",
    analytics_export_stores: "Download CSV",
    analytics_export_participants: "Download CSV",
    analytics_export_feedback: "Download CSV",
    analytics_store: "Store",
    analytics_learners: "Learners",
    analytics_unique_learners: "Unique learners",
    analytics_started: "Started",
    analytics_completed: "Completed",
    analytics_avg_score: "Avg score",
    analytics_no_store_data: "No store data available yet",
    analytics_participants: "participants",
    analytics_participants_in_store: "Participants in {store}",
    analytics_no_participants: "No participants found",
    analytics_last_activity: "Last activity",
    analytics_first_activity: "First activity",
    analytics_status_completed: "Completed",
    analytics_status_started: "Started",
    analytics_status_not_started: "Not started",
    analytics_attempts: "Attempts",
    analytics_quiz_score: "Quiz score",
    analytics_correct_answers: "Correct answers",
    analytics_total_questions: "Total questions",
    analytics_time_spent: "Time spent",
    analytics_score: "Score",
    analytics_status: "Status",
    analytics_participant_name: "Participant name",
    analytics_date_range: "Date range",
    analytics_filter_training: "Training",
    analytics_filter_store: "Store",
    // Feedback table
    analytics_feedback_title: "Participant feedback",
    analytics_feedback_date: "Date",
    analytics_feedback_time: "Time",
    analytics_feedback_store: "Store",
    analytics_feedback_name: "Name",
    analytics_feedback_text: "Feedback",
    analytics_feedback_language: "Language",
    analytics_no_feedback: "No feedback received yet",
    analytics_feedback_count: "{count} feedback messages",
    // CSV column headers (must match backend)
    analytics_csv_store_id: "Store ID",
    analytics_csv_store_name: "Store",
    analytics_csv_views: "Views",
    analytics_csv_started: "Started",
    analytics_csv_completed: "Completed",
    analytics_csv_completion_rate: "Completion rate",
    analytics_csv_avg_score: "Avg score",
    analytics_csv_unique_learners: "Unique learners",
    analytics_csv_learner_name: "Participant name",
    analytics_csv_first_name: "First name",
    analytics_csv_last_name: "Last name",
    analytics_csv_status: "Status",
    analytics_csv_attempts: "Attempts",
    analytics_csv_total_questions: "Total questions",
    analytics_csv_correct_answers: "Correct answers",
    analytics_csv_score_percent: "Score %",
    analytics_csv_time_spent: "Time (sec)",
    analytics_csv_first_activity: "First activity",
    analytics_csv_last_activity: "Last activity",
    analytics_csv_feedback_text: "Feedback",
    analytics_csv_timestamp: "Timestamp",

    // Player – start screen
    player_start_title: "Welcome to this training",
    player_start_welcome: "Welcome to {courseName}",
    player_start_intro: "Confirm your details to get started",
    player_start_store_label: "Which store do you work at? *",
    player_start_store_label_mystery_shop: "Which store are you visiting? *",
    player_start_store_label_guide: "What context are you viewing this for? *",
    player_start_store_placeholder: "Select your store",
    player_start_store_error: "Select a store",
    player_start_first_name_label: "First name *",
    player_start_first_name_placeholder: "Your first name",
    player_start_first_name_error: "First name is required",
    player_start_last_name_label: "Last name *",
    player_start_last_name_placeholder: "Your last name",
    player_start_last_name_error: "Last name is required",
    player_start_info: "This information helps us improve the training and is linked to your progress.",
    player_start_button: "Start Training",
    player_start_button_mystery_shop: "Start visit",
    player_start_button_guide: "Start guide",

    // Player – nav
    player_nav_previous: "Previous",
    player_nav_next: "Next",
    player_nav_finish: "Finish",
    player_watch_more: "Watch {seconds} more seconds",
    player_watch_to_end: "Watch the video until the end first",
    player_wait_more: "Wait {seconds} more seconds",
    player_complete_first: "Complete this section first",

    // Player – quiz
    quiz_select_answer: "Select an answer",
    quiz_confirm: "Confirm Answer",
    quiz_your_answer: "Your answer",
    quiz_reflection: "This question has no right or wrong answer. It's for reflection.",
    quiz_reflection_mystery_shop: "Share your observation. There is no right or wrong answer.",
    quiz_reflection_guide: "There is no right or wrong answer.",
    quiz_comment_label: "Comment (optional)",
    quiz_comment_placeholder: "Add a comment...",
    quiz_comment_submit: "Save comment",
    quiz_comment_skipped: "No comment added",
    quiz_correct: "Correct! 🎉",
    quiz_incorrect: "Not quite...",
    quiz_expl_correct_label: "Explanation for correct answer (optional)",
    quiz_expl_correct_placeholder: "Shown when the learner chooses the correct answer...",
    quiz_expl_incorrect_label: "Explanation for incorrect answers (optional)",
    quiz_expl_incorrect_placeholder: "Shown when the learner chooses a wrong answer...",
    quiz_explanation_label: "General explanation (optional, deprecated)",
    quiz_multiple_answers: "Allow multiple answers",
    quiz_single_answer_hint: "Single answer (radio)",
    quiz_multiple_answer_hint: "Multiple answers (checkbox)",
    quiz_locked: "Your answer has been saved",

    // Player – completion + feedback
    completion_title: "Training Completed!",
    completion_title_mystery_shop: "Visit completed!",
    completion_title_guide: "Guide completed!",
    completion_subtitle: "You successfully completed {courseName}",
    completion_subtitle_mystery_shop: "Thank you for your visit!",
    completion_subtitle_guide: "Well done! You've completed the guide.",
    completion_name_label: "Name",
    completion_store_label: "Store",
    feedback_title: "Optional Feedback",
    feedback_help: "Help us improve this training. What was good? What could be better?",
    feedback_help_mystery_shop: "How was your experience?",
    feedback_help_guide: "How did you find this guide?",
    feedback_placeholder: "Share your experiences, tips, or suggestions...",
    feedback_chars: "characters",
    feedback_submit: "Send Feedback & Close",
    feedback_submitting: "Sending...",
    feedback_skip: "Skip",
    feedback_sent_title: "Feedback sent!",
    feedback_sent_body: "Thanks for your feedback.",
    feedback_enter_first: "Enter feedback first",

    // Closed screen
    closed_title: "You're done 🎉",
    closed_body: "You can now close this window.",

    // Misc
    error_media_could_not_load: "Media could not be loaded. You can continue.",
    unavailable_title: "Training unavailable",
    not_found: "Not found"
  }
};
